export default {
    title: "Your Personalized Experience",
    loading1: "Configuring",
    loading2: "Analyzing your orders",
    loading3: "Generating Recommendations",
};
